import styled from 'styled-components'

type LabelProps = {
  visible: boolean
}

export const Label = styled.span<LabelProps>`
  color: ${({ visible }) => (visible ? 'inherit' : 'transparent')};
`

Label.displayName = 'Label'
